module.exports = __webpack_public_path__ + "static/media/DAPSdarklogo.ceeaf7c4.png";